// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__Au6WE","image":"Loader_image__8wL+P","large":"Loader_large__-YThI","small":"Loader_small__TSIUh","overlay":"Loader_overlay__3Vcda"};